import React from 'react';
import { Container, Row, Col } from 'reactstrap';


const deg = {
    fontSize : '12px',
    background: '#D6EBF0'
    // background: 'rgba(252,234,187,1)',
    // background: '-moz-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-webkit-gradient(left top, left bottom, color-stop(0%, rgba(252,234,187,1)), color-stop(42%, rgba(252,205,77,1)), color-stop(88%, rgba(248,182,5,1)), color-stop(91%, rgba(248,181,0,1)), color-stop(100%, rgba(251,223,147,1)))',
    // background: '-webkit-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-o-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-ms-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: 'linear-gradient(to bottom, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#fceabb\', endColorstr=\'#fbdf93\', GradientType=0 )'
}


const title = {
    textAlign: 'center',
    fontSize: '18px',
    color: 'black',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '700'
}

const txt2 = {
    textAlign: 'center',
    fontSize: '14px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '700'
}

const mystyle = {
    maxWidth: '100%',
    height: 'auto'
}

const conttxt = {
    textAlign: 'center',
    background: '#DBF088',
    borderRadius: '6px'
}



const ImageRecord1 = () => {
    return(
        <Container style={deg}>
            <Row>
                <Col style={title}>¡Gracias!</Col>
            </Row>
            <Row>
                <Col style={txt2}>Estamos cargando tu respuesta, por favor espera unos segundos mas</Col>
            </Row>
            <Row>
                <Col style={txt2}>¿Sabías que en muchos casos la decisión de contratar o no a un <br></br> candidato se toma en los primeros segunos?</Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <img style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/MujerV.png`} alt="Smiley face" />
                    <div style={conttxt}>
                        <label>La noche previa procura dormir bien para que llegues descansado</label>
                    </div>
                </Col>
                <Col xs={6} >
                    <img style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/RelogV.png`} alt="Smiley face" />
                    <div style={conttxt}>
                        <label>Intenta llegar 15 minutos antes de tu entrevista</label>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <img  style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/ChiclesV.png`} alt="Smiley face" />
                    <div style={conttxt}>
                        <label>No ingreses a la entrevista masticando chicle</label>
                    </div>
                </Col>
                <Col xs={6} >
                    <img  style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/CelularV.png`} alt="Smiley face" />
                    <div style={conttxt}>
                        <label>Coloca tu celular en modo silencioso</label>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ImageRecord1;